/**
 * @fileoverview Flow Editor Vuex module for managing conversational flows.
 * @module store/modules/floweditor
 *
 * This module provides functionality for:
 * - Creating, editing, and deleting conversational flows
 * - Managing flow sections, questions, and suggested answers
 * - Previewing flows across different channels
 * - Fetching flow execution results and analytics
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { FlowEditorState } from "./types";
import { RootState } from "@/store/types";

const floweditor: Module<FlowEditorState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default floweditor;
